import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { allowVideoUrl } from '../../constants';
import { CommonHttpService } from '../../services/common-http/common-http.service';
import { ElectronService } from '../../services/electron/electron.service';

@Component({
    selector: 'app-vplaybook-video-viewer',
    templateUrl: './vplaybook-video-viewer.component.html',
    styleUrls: ['./vplaybook-video-viewer.component.scss'],
    standalone: false
})
export class VplaybookVideoViewerComponent {

  primaryUrl: string;
  videoSrc: string;
  isPlaying: boolean;
  offlineAppPath: any;
  onErrorCalled = 0;
  onErrorFuncAllowed = true;
  @ViewChild('videoPlayer') videoPlayer: ElementRef<any>;
  @Input() videoAssetId: string;
  @Input() isLoadVideo: boolean = true;
  @Input() videoClass: string = 'wh-100';
  @Input() isTimeUpdate: boolean = false;
  @Input() onErrorRetry: number = 3;
  @Input() isEmbedThirdPartyUrl: boolean = false;
  @Input() public set setVideoSrc(videoSrc: string) {
    this.videoSrc = videoSrc;
    this.fetchVideoUrl();
  }
  @Input() public set setIsPlaying(isPlaying: boolean) {
    this.isPlaying = isPlaying;
    this.playVideo();
  }

  @Output() onTimeUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onAddVideoComment: EventEmitter<any> = new EventEmitter();
  @Output() downloadAsset: EventEmitter<any> = new EventEmitter();

  constructor(
    private commonHttpService: CommonHttpService,
    private electronService: ElectronService
  ) {
    this.offlineAppPath = this.electronService.appPath;
  }

  playVideo() {
    // setIsPlaying() is an @Input setter that runs during the first change
    // detection pass, before ngAfterViewInit resolves the #videoPlayer
    // ViewChild. Guard against the not-yet-available element so we no-op
    // instead of throwing "Cannot read properties of undefined".
    if (this.videoSrc && this.videoPlayer && this.videoPlayer.nativeElement) {
      if (this.isPlaying) {
        this.videoPlayer.nativeElement.play();
      } else if (!this.videoPlayer.nativeElement.pause()) {
        this.videoPlayer.nativeElement.pause();
      } else if (this.videoSrc.includes('data') || this.videoSrc.includes(this.offlineAppPath)) {
        //  data url and offline
      }
    }
  }
  loadVideo() {
    setTimeout(() => {
      if (!this.videoPlayer || !this.videoPlayer.nativeElement) {
        return;
      }
      this.videoPlayer.nativeElement.play();
      setTimeout(() => {
        if (this.videoPlayer && this.videoPlayer.nativeElement) {
          this.videoPlayer.nativeElement.pause();
        }
      }, 100);
    }, 1000);
  }

  fetchVideoUrl(isCurrentTime = false) {
    let currentTime;
    if (isCurrentTime && this.videoPlayer && this.videoPlayer.nativeElement) {
      currentTime = this.videoPlayer.nativeElement.currentTime;
      this.onErrorCalled++;
      if (this.onErrorCalled === this.onErrorRetry) {
        this.onErrorFuncAllowed = false;
      }
    }
    if (this.videoSrc.includes('data')
    || this.videoSrc.includes(this.offlineAppPath) 
    || this.videoSrc.includes(environment.saasTokenDomain)
    || this.videoSrc.includes(allowVideoUrl)
    || this.isEmbedThirdPartyUrl) {
      this.primaryUrl = this.videoSrc;
      this.loadVideo();
    } else {
      this.commonHttpService.get<any>({
        uri: this.videoSrc,
        message: {
          showMessage: false
        }
      }).subscribe((videoDataUrl) => {
        if (isCurrentTime && this.videoPlayer && this.videoPlayer.nativeElement) {
          this.videoPlayer.nativeElement.src = videoDataUrl;
          this.videoPlayer.nativeElement.play();
          this.videoPlayer.nativeElement.currentTime = currentTime;
        } else {
          this.primaryUrl = videoDataUrl;
          if (this.isLoadVideo) {
            this.loadVideo()
          }
        }
      });
    }
  }

  onTimeUpdateFunc(currentTime) {
    if(this.isTimeUpdate) {
      this.onTimeUpdate.emit(currentTime);
    }
  }

  addVideoComment() {
    if (this.isTimeUpdate) {
      this.videoPlayer.nativeElement.pause();
      this.onAddVideoComment.emit();
    }
  }

  downloadAssetFunc(assetUrl) {
    if (this.isTimeUpdate) {
      this.downloadAsset.emit(assetUrl);
    }
  }
}
